<template>
  <div class="n8n-posts-history">
    <b-card>
      <h3 class="mb-3">
        {{ $t('menu.n8n-pages-history') }}
      </h3>
      <ok-table
        ref="datatable"
        :config="config"
        class="n8n-posts-history-table"
        @delete="handleDelete"
      >
        <template
          slot="status-column"
          slot-scope="{ props }"
        >
          <b-badge :variant="getStatusVariant(props.row.status)">
            {{ $t(`n8n.${props.row.status}`) }}
          </b-badge>
        </template>
        <template
          slot="error-column"
          slot-scope="{ props }"
        >
          <span v-if="props.row.error">{{ props.row.error }}</span>
          <span v-else>-</span>
        </template>
      </ok-table>
    </b-card>
  </div>
</template>

<script>
import { BBadge, BCard } from 'bootstrap-vue'
import OkTable from '@/@bya3/components/tables/ok-table/OkTable'
import N8nPagesApi from '@/api/n8n-pages'
import N8nPostsHistoryTableConfig from './config/n8n-posts-history-table-config'

export default {
  name: 'N8nPagesHistoryTable',
  components: {
    BCard,
    BBadge,
    OkTable,
  },
  data() {
    return {
      config: N8nPostsHistoryTableConfig,
    }
  },
  methods: {
    refreshTable() {
      this.$refs.datatable.loadItems()
    },
    getStatusVariant(status) {
      switch (status) {
        case 'completed':
          return 'success'
        case 'failed':
          return 'danger'
        case 'pending':
        default:
          return 'warning'
      }
    },
    handleDelete(props) {
      this.$okConfirm(this.$t('n8n.history-delete-confirm'), {
        preConfirm: () => N8nPagesApi.deleteN8nPageHistory(props.row.id)
          .then(() => {
            this.$notifySuccess(this.$t('n8n.history-deleted-successfully'))
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
  },
}
</script>
